"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingOption = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../i18n/i18n");
var _useTheme = require("../../../theme/utils/useTheme");
var _useHovered = require("../../../util/useHovered");
var _tooltip = require("../../tooltip");
var _visuallyhidden = require("../../visuallyhidden");
var _HiddenInput = require("../styled/HiddenInput");
var _RatingOptionStyled = require("../styled/RatingOptionStyled");
const RatingOption = _ref => {
  let {
    children,
    clientId,
    groupId,
    isDisabled = false,
    isReadonly = false,
    isSelected,
    onHover,
    onClick,
    value,
    name,
    className,
    omitSelectedTooltip = false
  } = _ref;
  const {
    i18n
  } = (0, _i18n.useI18n)();

  // Hovered state is reported back to the Rating parent component
  const {
    ...useHoveredHandlers
  } = (0, _useHovered.useHovered)({
    onMouseEnter: () => {
      onHover(value, true);
    },
    onMouseLeave: () => {
      onHover(value, false);
    }
  });
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const {
    tooltipProps,
    targetProps
  } = (0, _tooltip.useTooltip)({
    placement: "top",
    ...useHoveredHandlers
  });

  // This linkage is causing some WEIRD issues with JAWS. We'll just stick the text
  // directly into the selected option instead.
  // We replace this text with a live region to announce only when we want it to announce.
  // Otherwise the tooltip is read out multiple times.
  delete targetProps["aria-describedby"];

  // This ID connects the hidden checkbox to the hidden label for accessibility purposes
  const optionId = `${groupId}-rating-${value}`;
  const handleClick = (0, _react.useCallback)(e => {
    if (isDisabled || isReadonly) {
      return;
    }
    if (e.type === "change") {
      onClick(value, e);
    }
    if (e.type === "click" && isSelected) {
      onClick(value, e);
    }
    if (e.type === "keydown" &&
    // For key events, we only want Space and Enter to work.
    ["Enter", " "].includes(e.key)) {
      e.preventDefault();
      onClick(value, e);
    }
  }, [isDisabled, isReadonly, isSelected, onClick, value]);
  const clearSelectedMessage = i18n._( /* i18n */{
    comment: "A tooltip message within a rating component telling the user they can click/enter again to clear the rating.",
    id: "Click to clear selected rating"
  });
  return /*#__PURE__*/_react.default.createElement(_RatingOptionStyled.RatingOptionStyled, {
    themeMode: themeMode,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_HiddenInput.HiddenInput, (0, _extends2.default)({
    type: "radio",
    name: name,
    id: optionId,
    "data-client-id": (0, _lodestarUtils.getClientId)(clientId, `rating-${value}`),
    value: value.toString(),
    checked: isSelected,
    onClick: handleClick,
    onKeyDown: handleClick,
    onChange: handleClick,
    isDisabled: isDisabled || isReadonly,
    "aria-disabled": isDisabled || undefined,
    "aria-readonly": isReadonly || undefined
  }, targetProps)), children, /*#__PURE__*/_react.default.createElement(_visuallyhidden.VisuallyHidden, {
    "aria-live": "polite"
  }, isSelected && !omitSelectedTooltip && !isDisabled && !isReadonly ? clearSelectedMessage : ""), isSelected && !omitSelectedTooltip && !isDisabled && !isReadonly && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_tooltip.Tooltip, tooltipProps, /*#__PURE__*/_react.default.createElement(_tooltip.TooltipBody, null, clearSelectedMessage))));
};
exports.RatingOption = RatingOption;
//# sourceMappingURL=RatingOption.js.map